export default {"src":"/app/_next/static/media/hands-1.2246c185.svg","height":398,"width":398,"blurWidth":0,"blurHeight":0};